import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from "@angular/core";
import { ToasterService } from 'angular2-toaster';
import { BsModalRef } from "ngx-bootstrap";
import * as moment from 'moment';
import { CommonService, ServiceWalkInService, EditService } from "../../../services";
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
    selector: "app-service-reply",
    templateUrl: "./serviceReply.component.html"
})
export class serviceReplyComponent implements OnInit {
    @Output() servicReplyEvent = new EventEmitter();
    details: any;
    isLoading: boolean;
    reply: string;
    // hv_userid: number;
    isCompleted: boolean;
    nxt_fol_date: Date = new Date();
    view_title: any;
    hvUserCtrl: FormControl;
    hvUserList: any[] = [];
    filteredHvuserlist: Observable<any[]>;
    employeeList: any[];
    changeEmployeeDet: {
        ser_id: number,
        employee_id: number
    };

    @Input() set rowDetails(val: any) {
        if(val.view_type=='HV Delivery'){
            this.view_title = val.view_type;
            this.changeEmployeeDet = val;
        } else {
            this.details = val;
        }
    }

    constructor(public toasterService: ToasterService, public bsModalRef: BsModalRef, private serviceWalkInService: ServiceWalkInService, private editService: EditService, private commonService: CommonService) {
        this.hvUserCtrl = new FormControl();
        this.filteredHvuserlist = this.hvUserCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHvUser(name) : this.hvUserList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.getHVUserList();
    }

    onClickSubmit(): void {
        const that = this,
            data = this.details;
        data.reply = this.reply;
        data.isCompleted = this.isCompleted;

        if (!this.isCompleted && this.nxt_fol_date) {
            data['nxt_fol_date'] = moment(this.nxt_fol_date).format('YYYY-MM-DD');
        }

        this.isLoading = true;
        this.serviceWalkInService
            .serviceReply(this.details)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.servicReplyEvent.emit();
                } else {
                    that.toasterService.pop({
                        type: 'warning',
                        title: 'WARNING',
                        body: res.message
                    });
                }
            });
    }

    getHVUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        that.commonService
            .getHVUserList(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.hvUserList = res.data;
                }
            });
    }

    // HV User display
    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }

    assignFn(empid: any) {
        if (this.hvUserList != undefined) {
            if (empid && this.hvUserList.length > 0) {
                if (typeof empid == 'string') {
                    empid = parseInt(empid);
                }
                let fitem = _.find(this.hvUserList, { 'userid': empid });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';
    }

    onSaveChangEmployee(changeEmployeeID) {
        const employeeObj = _.find(this.hvUserList, { 'userid': changeEmployeeID });
        if(employeeObj){
            const changeEmployeeName = employeeObj['fullname'];

            if(this.changeEmployeeDet.employee_id == changeEmployeeID) {
                this.toasterService.pop({
                    type: 'warning',
                    title: 'WARNING',
                    body: "Same Employee can't be Changed"
                });
            } else {
                this.isLoading = true;
                this.editService
                    .modifyServiceDetails({
                        change_employee_name: changeEmployeeName,
                        transaction_type: "ServiceWalkin_ChangeBranch",
                        ser_id: this.changeEmployeeDet.ser_id,
                        change_employee_id: changeEmployeeID
                    })
                    .then((res: any) => {
                        this.isLoading = false;
                        if (res.success) {
                            this.changeEmployeeDet = {
                                ser_id: null,
                                employee_id: null
                            };
                            this.bsModalRef.hide();
                            this.servicReplyEvent.emit();
                            this.toasterService.pop({
                                type: 'success',
                                title: 'SUCCESS',
                                body: res.message
                            });
                        } else {
                            this.toasterService.pop({
                                type: 'warning',
                                title: 'WARNING',
                                body: res.message
                            });
                        }
                    });
                this.bsModalRef.hide();
            }
        } else {
            this.toasterService.pop({
                type: 'error',
                title: 'Error',
                body: "Please Select Valid Branch"
            });
        }
        
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/serviceReply.component.ts